import { PageTabBody } from "shared/components/layout/PageTabBody";
import { TableBox } from "shared/components/table/box/TableBox";
import { TableBoxBody } from "shared/components/table/box/TableBoxBody";
import { TableBoxHeader } from "shared/components/table/box/TableBoxHeader";
import { TableBoxTitle } from "shared/components/table/box/TableBoxTitle";
import { DataTable } from "shared/components/table/data/DataTable";
import { DataTableBoxActions } from "shared/components/table/data/DataTableBoxActions";
import { DataTableProps } from "shared/components/table/data/DataTableProps";

interface BasicTableTabProps extends DataTableProps {
  tableTitle: string;
  dataTableBoxActions?: React.ReactNode;
}

const BasicTableTab: React.FC<BasicTableTabProps> = ({
  tableTitle,
  dataTableBoxActions,
  ...tableProps
}) => (
  <PageTabBody>
    <TableBox>
      <TableBoxHeader>
        <TableBoxTitle>{tableTitle}</TableBoxTitle>
        {dataTableBoxActions ?? <DataTableBoxActions />}
      </TableBoxHeader>
      <TableBoxBody>
        <DataTable {...tableProps} />
      </TableBoxBody>
    </TableBox>
  </PageTabBody>
);

export default BasicTableTab;
